import React from "react";
import { Link } from "react-router-dom";
import './Strap.css';




const StrapDisplay =(props) =>{

    const listcategory =({categoriesData})=>{
        if (categoriesData){
            return categoriesData.map((item)=>{
                return(
                    <Link key={item._id} to={`/listing/${item.category_id}`} style={{ textDecoration: 'none'}}>
                        <div className="card align-items-center m-3 bg-dark tphd" >
                            <img src={item.image} className="card-img-top tph p-1 w-50" alt="scooter"/>
                          
                                <button className="btn btn-outline-warning mb-1  tpdt" type="button" >
                                    {item.category}
                                </button>
                           
                        </div>
                    
                    </Link>
                )
            })
        }else{
            return(
                <div>
                    <img  src="https://monophy.com/media/UQ4KgQnlpvTcUOXrur/monophy.gif" id="mc"/>
                </div>
            )
        }
    }
    return(
        
            
                <div className="d-flex justify-content-center w-100 ">
                    <div className="d-flex">
                        {listcategory(props)}
                    </div>
                    
                   
                    
                
                </div>
        
            
    )
}


export default StrapDisplay;